async function fetchAllGalleryEntries() {
  let entries = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const query = `
      query {
        metaobjects(type: "gallery", first: 100, after: ${cursor ? `"${cursor}"` : null}) {
          edges {
            cursor
            node {
              id
              image: field(key: "image") {
                reference {
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                }
              }
              products: field(key: "products") {
                references(first: 50) {
                  edges {
                    node {
                      ... on Product {
                        id
                        handle
                        title
                      }
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `;

    const res = await fetch("https://modular-closets.myshopify.com/api/2024-07/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "6d52cece673c6be07fb0e69ad769a3cc"
      },
      body: JSON.stringify({ query })
    });

    const data = await res.json();
    const edges = data.data.metaobjects.edges;

    // Flatten into simpler objects
    const pageEntries = edges.map(e => ({
      id: e.node.id,
      imageUrl: e.node.image?.reference?.image?.url || null,
      products: e.node.products?.references?.edges.map(pe => pe.node) || []
    }));

    entries = entries.concat(pageEntries);

    hasNextPage = data.data.metaobjects.pageInfo.hasNextPage;
    if (hasNextPage) cursor = edges[edges.length - 1].cursor;
  }

  return entries;
}

function normalizeId(id) {
  // Example input: "gid://shopify/Product/1234567890"
  // Returns: "1234567890"
  return id.split("/").pop();
}

document.addEventListener("DOMContentLoaded", async () => {
  const wrapper = document.querySelector(".product-gallery_product-wrapper");
  if (!wrapper) return;

  const currentProductId = wrapper.dataset.productId;
  const galleryData = await fetchAllGalleryEntries();
  console.log('gallery data:', galleryData);

  let hasImages = false;

  galleryData.forEach(entry => {
    if (!entry.products || !entry.imageUrl) return;

    const match = entry.products.some(p => normalizeId(p.id) === currentProductId);

    if (match) {
      hasImages = true;

      // render div + img elements
      const div = document.createElement("div");
      div.className = "product-gallery_product";

      const link = document.createElement("a");
      link.href = entry.imageUrl; // large image for lightbox
      link.className = "product-gallery_link";

      const img = document.createElement("img");
      img.src = entry.imageUrl + "&width=600&height=600";
      img.alt = "Gallery image";
      img.loading = "lazy";

      link.appendChild(img);
      div.appendChild(link);
      wrapper.appendChild(div);
    }
  });

  // Section starts hidden (see product-gallery.liquid) so an empty gallery never
  // appears and then collapses; reveal it only once there are images, before slick measures it
  if (hasImages) {
    const gallerySection = document.querySelector('.product-gallery');
    if (gallerySection) {
      gallerySection.style.display = "";
    }
  }

  // Initialize lightbox AFTER images are in DOM
  if (wrapper.querySelectorAll("a").length > 0)
    $(wrapper).slickLightbox({
      itemSelector: 'a',
      navigateByKeyboard: true,
      slick: {
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'></button>"
      }
    });

  // Always a slick carousel — desktop shows 4.7 at a time, mobile 1.1
  if (wrapper.querySelectorAll(".product-gallery_product").length > 0) {
    $(wrapper).slick({
      slidesToShow: 4.7,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1.1,
            adaptiveHeight: true
          }
        }
      ]
    });
  }
});
